import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';

const ToggleEditButton = ({ disabledEdit, onClick, onCancel }) => {
  const toggleEdit = () => {
    if (disabledEdit) {
      onClick();
    } else {
      onCancel();
    }
  };
  return (
    <Button
      startIcon={disabledEdit ? <EditIcon /> : <CloseIcon />}
      variant="secondary"
      size="small"
      onClick={toggleEdit}
    >
      Editar
    </Button>
  );
};

ToggleEditButton.propTypes = {
  disabledEdit: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ToggleEditButton;
